import { useState } from 'react';
// material
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';

// components
import Page from '../components/Page';
import TaxCategories from '../components/TaxCategories';
import LedgerCategories from '../components/LedgerCategories';
import AccountSettings from '../components/AccountSettings';

export default function AccountsSettings() {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Page title="Accounts Settings">
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" gutterBottom>
              Accounts Settings
            </Typography>
          </Stack>
          <Card>
            <Box sx={{ width: '100%', marginTop: '20px' }}>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange}>
                    <Tab label="Ledger Categories" value="1" />
                    <Tab label="Account Settings" value="2" />
                    <Tab label="Tax Categories" value="3" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <LedgerCategories />
                </TabPanel>
                <TabPanel value="2">
                  <AccountSettings />
                </TabPanel>
                <TabPanel value="3">
                  <TaxCategories />
                </TabPanel>
              </TabContext>
            </Box>
          </Card>
        </Container>
      </Page>
    </>
  );
}
